import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useActivateCoupon = (id: string) => {
  const {
    mutate: activate,
    isPending,
    data,
  } = useAppMutation([QueryKey.ACTIVATE_COUPON], {
    mutationFn: ({ coupon }: { coupon: string }) =>
      ApiService.get<{ clientSecret: string }>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [id, 'activate-coupon', coupon],
      }),
  });
  return { activate, isPending, data };
};
